import type { ReportConfig } from '../../types/panelConfig';

/**
 * Sube suzgeci — 040 gibi `lokasyon` kolonu TASIYAN raporlar icin.
 *
 * Suzme ISTEMCIDE yapilir: 040'in kendisi @LOKASYON parametresi ALMIYOR ve
 * o rapor paylasilan bir yuzey (SQL'ine dokunulmaz). Satirlar zaten
 * lokasyonu tasidigi icin sunucuya ikinci bir cagri gerekmiyor - ayni
 * onbellek girdisi hem "tum subeler" hem tek sube goruntusunu besler.
 *
 * `sube` null ise HICBIR SEY suzulmez (kimlik). Eslesme birebir metin
 * karsilastirmasi: secenek listesi de ayni kolondan turedigi icin
 * normalizasyona gerek yok, ve gevsek eslesme (ILIKE benzeri) iki subenin
 * adi birbirini kapsadiginda sessizce yanlis kume dondururdu.
 */
export function subeSuz<T extends { lokasyon: unknown }>(rows: T[], sube: string | null): T[] {
  if (sube === null) return rows;
  return rows.filter((r) => String(r.lokasyon ?? '') === sube);
}

/** `magaza` kolonu tasiyan raporlar icin (011 İade Analizi) ayni kural. */
export function magazaSuz<T extends { magaza: unknown }>(rows: T[], sube: string | null): T[] {
  if (sube === null) return rows;
  return rows.filter((r) => String(r.magaza ?? '') === sube);
}

/**
 * @LOKASYON parametresi ALAN raporlar icin parametre ekler. Rapor
 * parametreyi `coalesce(@LOKASYON,'')=''` kaliplariyla OPSIYONEL isliyor,
 * yani bos metin "tum subeler" demek.
 */
export function lokasyonDestekli(rapor: ReportConfig | undefined): boolean {
  return !!rapor?.parameters?.some((p) => p.key.toUpperCase().includes('LOKASYON'));
}

export function lokasyonParam(sube: string | null, destekli: boolean): Record<string, string> {
  return sube === null || !destekli ? {} : { '@LOKASYON': sube };
}
